import React,{Component} from 'react';

import {Header} from '../header/Header';
import {Footer} from '../footer/Footer';

export class DateSheet extends Component{
    render(){
        return(
            <>
            <Header></Header>
            <br/>
            <br/>
            <br/>
            <div className="container text-center">
                 <h2>Date Sheet</h2>
                 <ul>
                    <li><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/DATE%20SHEET%202nd%20PHASE%20HSC%20ANNUAL%20EXAMINATION%202018.pdf?alt=media&token=001cfed1-d479-40e7-a357-3784efb80a9f">Consolidated DateSheet of Humanities (Reg & Pvt), Special Students (New)</a></li>
                    <li><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/DATE%20SHEET%20HSC%20ANNUAL%20EXAMINATION%202018%20(1).pdf?alt=media&token=0152916c-81d6-4db5-affe-4704199d5705 ">Consolidated DateSheet for Annual Examinations 2018 (New)</a></li>
                    <li><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/final%20Date%20Sheet%20Supply%202017-27-11-17.pdf?alt=media&token=54499d23-6544-47a9-98e1-e7b9ff1510ac">Consolidated Datesheet for Supplimentry Examinations 2017</a></li>
                    <li><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/ConsolidatedDateSheet%20Annual2017.pdf?alt=media&token=4bb92453-6a3d-49c6-99e2-0b5e21e07709">Datesheet of the Annual Examinations 2017 (Phase - I)</a></li>
                    <li><a href="#">Datesheet of the Annual Examinations 2017 (Phase - II)</a></li>
                 </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}